import React from 'react';
import { Link } from 'react-router-dom';

export default function Echo2D() {
  return (
    <>
      <div className='services-item container' id='echo2d'>
        <div className='row'>

          {/* Image */}
          <div className='col-lg-6 col-md-6 col-sm-12 p-0'>
            <img
              className="img-fluid"
              src={`${process.env.PUBLIC_URL}/img/2d.png`}
              alt="2D Echo"
            />
          </div>

          {/* Description */}
          <div className='col-lg-6 col-md-6 col-sm-12 v-align-middle p-0'>
            <div className='services-item-content'>
              <h2>2D <span>Echo</span></h2>

              <p>
                Our 2D Echocardiography service offers a detailed assessment of your
                heart's structure and function using advanced ultrasound technology.
                It helps detect heart valve disorders, chamber abnormalities,
                congenital heart diseases, and evaluates overall cardiac performance
                safely and painlessly.
              </p>

              <Link to="/contact" className="btn theam-btn-m">
                Contact Us
              </Link>
            </div>
          </div>

        </div>
      </div>
    </>
  );
}